import { SchoolOutlined } from 'components/icons';
import { Tooltip } from 'components/ui/tooltip';
import StyledHeaderButton from 'layout/MainLayout/Header/HeaderContent/actions/StyledHeaderButton';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import { useLearningMode } from './useLearningMode';

export function LearningModeToggle() {
    const { isAvailable, isEnabled, setIsEnabled } = useLearningMode();
    if (!isAvailable) return null;
    const label = t(isEnabled ? 'learning-mode.turn-off' : 'learning-mode.turn-on');
    return (
        <Tooltip content={label}>
            <StyledHeaderButton
                aria-label={label}
                aria-pressed={isEnabled}
                onClick={() => setIsEnabled(!isEnabled)}
                className={cn(isEnabled && 'bg-secondary hover:bg-secondary/80 text-secondary-foreground')}
            >
                <SchoolOutlined className="text-base!" />
            </StyledHeaderButton>
        </Tooltip>
    );
}
